import { render, staticRenderFns } from "./kaijilv.vue?vue&type=template&id=77a0e67c&"
import script from "./kaijilv.vue?vue&type=script&lang=js&"
export * from "./kaijilv.vue?vue&type=script&lang=js&"
import style0 from "./kaijilv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports